import initApiAuth from './auth';
import initEnergyComm from './energyCommunities';
import initApiRoleBase from './rolebase';
import initApiTemplate from './template';
import initApiTemplateV2 from './templateV2';
import initApiTicket from './ticket';

export default (apiConfig) => ({
  auth: initApiAuth(apiConfig),
  energyCommunities: initEnergyComm(apiConfig),
  rolebase: initApiRoleBase(apiConfig),
  template: initApiTemplate(apiConfig),
  templateV2: initApiTemplateV2(apiConfig),
  ticket: initApiTicket(apiConfig),
});
